import { ApiError } from './api';
import type { Dictionary } from '../i18n/es-MX';

/** Turn any thrown value into a localized, user-facing message (craft tone, never raw codes). */
export function apiErrorMessage(err: unknown, t: Dictionary): string {
  if (err instanceof ApiError) {
    if (err.status === 0 || err.code === 'network') return t.errors.network;
    if (err.isRateLimited) return t.errors.rateLimited(err.retryAfter ?? 60);
    if (err.isUnauthorized) return t.errors.unauthorized;
    if (err.status === 404) return t.errors.notFound;
    if (err.status === 413 || err.code === 'payload_too_large') return t.errors.tooLarge;
    if (err.status === 415 || err.code === 'unsupported_media_type') return t.errors.unsupported;
    // Prefer the server message when it is human-ish, else the generic craft line.
    return err.message && err.message.length < 120 ? err.message : t.errors.generic;
  }
  if (err instanceof DOMException && err.name === 'AbortError') return '';
  return t.errors.generic;
}
